
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/idee-verdi/c/[...slug]",
      function () {
        return require("private-next-pages/idee-verdi/c/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/idee-verdi/c/[...slug]"])
      });
    }
  